<template>
  <tk-flex middle class="bg-w c-date-picker">
    <div class="p-x-10 p-y-4 unshrink unwrap label font-14">{{ label }}</div>
    <a-range-picker v-bind="$attrs" v-on="$listeners" size="small">
      <a-icon slot="suffixIcon" type="calendar" />
    </a-range-picker>
  </tk-flex>
</template>
<script>
export default {
  name: 'DateRangePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>
<style>

</style>

<style scoped lang="less">
.c-date-picker {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.label {
  border-right: 1px solid #d9d9d9;
}
.c-date-picker:hover {
  border: 1px solid #2FBF79;
}
::v-deep .ant-input {
  border: 0px;
}
::v-deep .ant-input:hover {
  border: 0px;
}
</style>
